import { CircleHelpIcon } from 'lucide-react'
import { Tooltip, TooltipContent, TooltipTrigger } from '@rentflowdev/ui'

interface FieldHintProps {
	/** The explanation itself, already translated. */
	text: string
	/** Announced to screen readers, which cannot see the icon. */
	label?: string
}

/**
 * A «?» beside a field label, explaining a term the label cannot.
 *
 * Some options are only obvious to someone who already knows the domain:
 * «Открытая планировка» reads as a guess until you are told it means desks in
 * one room rather than separate offices. Avito puts the same hint on the same
 * fields — a landlord filling both forms should not have to learn the word
 * twice.
 *
 * TooltipProvider is mounted once in the app layout, so this works anywhere
 * inside it.
 */
export function FieldHint({ text, label = 'Подсказка' }: FieldHintProps) {
	return (
		<Tooltip>
			<TooltipTrigger
				render={
					<button
						type="button"
						aria-label={label}
						// Nothing to submit and nothing to focus past: this only
						// explains the field it sits next to.
						tabIndex={-1}
						className="inline-flex shrink-0 text-(--color-muted-foreground) transition-colors hover:text-(--color-foreground)"
					/>
				}
			>
				<CircleHelpIcon className="size-4" />
			</TooltipTrigger>
			<TooltipContent className="max-w-64">{text}</TooltipContent>
		</Tooltip>
	)
}
